export default function About() {
  return (
    <main className="page">
      <header className="about__hero">
        <h1>About</h1>
      </header>

      <div className="about__grid">
        <div className="about__bio">
          <p>
            I grew up moving. Micronesia at two, Japan at twelve, New Haven at twenty-two —
            where I graduated from Yale with a degree in International Relations on a full fellowship.
            Living across cultures early taught me something that has shaped everything since:
            the way you frame a problem is often more important than the solution you propose.
          </p>
          <p>
            I spent several years in education — teaching, building tutoring programs, earning
            credentials — before moving into tech. At Amazon's TenMarks I built a content
            strategy function from scratch, shaping the narrative for Amazon's entry into
            the K-12 English Language Arts market. Then Workday, where I've spent the last
            ten years.
          </p>
          <p>
            At Workday I've held three distinct roles: Manager of Content Design (where I
            founded the practice and introduced "Content Early" — using narrative to shape
            product strategy before a line of code is written), Director of Product Design
            (leading a 75-person multidisciplinary org across the full product portfolio),
            and Director of Product Management (defining the experience narrative and product
            vision for Workday's AI platform).
          </p>
          <p>
            The thread across all of it: I believe narrative is a product strategy tool,
            not a marketing one. The companies that figure that out early build better
            products, close harder deals, and earn the kind of trust that compounds.
          </p>
          <p>
            I'm passionate about AI that is built responsibly — not as a compliance exercise,
            but as a product property that makes the technology genuinely trustworthy for
            the people who use it every day.
          </p>
        </div>

        <div className="about__sidebar">
          <div className="about__section">
            <span className="about__section-label">Education</span>
            <ul className="about__list">
              <li><strong>Yale University</strong> — MA, International Relations (Yale Fellowship)</li>
              <li><strong>Brandeis University</strong> — BA, English (Summa Cum Laude, Phi Beta Kappa)</li>
              <li><strong>SF State University</strong> — MA, Education</li>
            </ul>
          </div>

          <div className="about__section">
            <span className="about__section-label">Experience</span>
            <ul className="about__list">
              <li><strong>Workday</strong> — Director, Product Management (2018–present)</li>
              <li><strong>Workday</strong> — Director, Product Design</li>
              <li><strong>Workday</strong> — Manager, Content Design</li>
              <li><strong>Amazon / TenMarks</strong> — Manager, Content Strategy (2013–2018)</li>
            </ul>
          </div>

          <div className="about__section">
            <span className="about__section-label">Currently seeking</span>
            <ul className="about__list">
              <li>CPO or VP Product roles</li>
              <li>AI-native companies</li>
              <li>San Francisco Bay Area</li>
            </ul>
          </div>

          <div className="about__section">
            <span className="about__section-label">Volunteer</span>
            <ul className="about__list">
              <li><strong>Palisades Tahoe Community Foundation</strong> — Board of Directors</li>
              <li><strong>Mission Learning Center</strong> — Founded 1:1 tutoring program for low-income English Language Learners</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="about__beliefs">
        <h2>What I believe about product</h2>
        <div className="belief-grid">
          <div className="belief-item">
            <h3>Narrative is strategy</h3>
            <p>
              The best product decisions start with a clear story of who this is for and
              why it matters. Story isn't the wrapper around strategy — it is the strategy.
            </p>
          </div>
          <div className="belief-item">
            <h3>Trust is a product property</h3>
            <p>
              Enterprise AI fails when companies treat trust as a marketing message.
              It has to be built into the product: explainability, user control,
              transparent failure modes.
            </p>
          </div>
          <div className="belief-item">
            <h3>Adoption is a design problem</h3>
            <p>
              You can ship the right product and still fail if you haven't solved for
              how people build fluency with it. Sequencing and onboarding are product
              decisions, not afterthoughts.
            </p>
          </div>
        </div>
      </section>

      <div className="contact-strip">
        <div>
          <h2>Let's talk.</h2>
          <p>Currently exploring CPO and VP Product opportunities at AI-native companies.</p>
        </div>
        <a href="mailto:simoneaehrlich@gmail.com" className="btn">simoneaehrlich@gmail.com</a>
      </div>
    </main>
  );
}
